import * as ActionTypes from './index';

export function fetchQuestionAnswerRevisions(payload) {
    return {
        type: ActionTypes.FETCH_QUESTION_ANSWER_REVISIONS,
        payload: payload
    }
}

export function fetchQuestionAnswerRevisionsSuccess(payload) {
    return {
        type: ActionTypes.FETCH_QUESTION_ANSWER_REVISIONS_SUCCESS,
        payload: payload
    }
}

export function fetchQuestionAnswerRevisionsFailed(payload) {
    return {
        type: ActionTypes.FETCH_QUESTION_ANSWER_REVISIONS_FAILED,
        payload: payload
    }
}